import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import { Button, PrimaryButton } from 'app/blocks/buttons/buttons';
import Panel from 'app/blocks/Panel/Panel';

class PanelAdvanced extends React.Component {
    static propTypes = {
        panel: PropTypes.shape({}).isRequired,
    };

    componentDidMount() {
        // eslint-disable-next-line react/no-find-dom-node
        this.props.panel.initPanelDomNode(ReactDOM.findDOMNode(this.panel));
    }

    render() {
        const {
            panel,
            headerTitle,
            descr,
            toggleEventDone,
            toggleEventStart,
            seleniumid,
            children,
            hideCtrlBtn,
            disableCancel,
            disableOk,
        } = this.props;

        const panelInfo = panel.getPanelInfo();

        return (
            <Panel
                ref={ref => {
                    this.panel = ref;
                }}
                closed={!panelInfo.open}
                descr={descr}
                header={headerTitle}
                seleniumid={seleniumid}
                status={panelInfo.status}
                toggleEventDone={toggleEventDone}
                toggleEventStart={toggleEventStart}
                togglePanel={() => panel.togglePanel()}
                warnMessage={panelInfo.validationResults && panelInfo.validationResults.message}
            >
                {children}

                {!hideCtrlBtn && (
                    <div className="mt-2x">
                        <Button
                            data-seleniumid={`${seleniumid}-cancel-button`}
                            disabled={panelInfo.locked || disableCancel}
                            onClick={() => panel.cancel()}
                        >
                            Cancel
                        </Button>
                        <PrimaryButton
                            className="pull-right"
                            data-seleniumid={`${seleniumid}-ok-button`}
                            disabled={panelInfo.locked || disableOk}
                            onClick={() => panel.confirm()}
                        >
                            {panelInfo.locked ? 'Processing...' : 'Ok'}
                        </PrimaryButton>
                    </div>
                )}
            </Panel>
        );
    }
}

export default PanelAdvanced;
